/**
 * Feature flag della direttiva "Proprietà Personalizzate".
 *
 * Il flag `ENABLE_WIDGET_CUSTOM_PROPERTIES` nasconde SOLO l'interfaccia di
 * configurazione (via `allowsWidget`): la direttiva resta comunque registrata.
 * Disattivo di default (assente ⇒ non abilitato).
 */
export class WidgetCustomPropertiesLogic {
  static isEnabled() {
    return process.env.ENABLE_WIDGET_CUSTOM_PROPERTIES === 'true';
  }
}
